module.exports = __webpack_public_path__ + "img/shop_A_1.3422ac5f.png";